export default "__VITE_ASSET__1210be8d__"